import React, { useMemo } from "react";
import PropTypes from "prop-types";
import CartDrawerUpsellStrip from "../CartDrawer/CartDrawerUpsellStrip";
import AiBrandAttribution from "../../layouts/ai-recommendation-upsell/components/AiBrandAttribution";
import {
  getStaticProductPageUpsellSections,
  STATIC_PRODUCT_PAGE_UPSELL_SECTION_INDEX,
} from "../../constants/product-page-upsell-template";
import { isSectionVisible } from "../../../shared/section-visibility.js";
import { isProductPageBundleSelectionLayout } from "./ProductPageUpsellSelectionContext";

/**
 * Live storefront product page upsell mounted inside a theme slot div.
 */
export default function RenderProductPageUpsellSlot({
  popupData,
  activeStep = 0,
  isMobile,
}) {
  const sections = useMemo(
    () => getStaticProductPageUpsellSections(popupData, activeStep),
    [popupData, activeStep]
  );

  const headingSection =
    sections[STATIC_PRODUCT_PAGE_UPSELL_SECTION_INDEX.UPSELL_HEADING];
  const productSection =
    sections[STATIC_PRODUCT_PAGE_UPSELL_SECTION_INDEX.UPSELL_PRODUCT];
  const brandSection =
    sections[STATIC_PRODUCT_PAGE_UPSELL_SECTION_INDEX.BRAND_ATTRIBUTION];

  const isBundleLayout = isProductPageBundleSelectionLayout(productSection);

  const showBrand = brandSection && isSectionVisible(brandSection);

  return (
    <div
      className="weupsell-product-page-upsell-slot"
      data-weupsell-surface="product-page"
      style={{ overflow: "visible" }}
    >
      <CartDrawerUpsellStrip
        popupData={popupData}
        headingSection={headingSection}
        productSection={productSection}
        activeStep={activeStep}
        isPreviewMode={false}
        isMobile={isMobile}
        surface="product-page"
        enableProductPageBundleSelection={isBundleLayout}
      />
      {showBrand ? (
        <AiBrandAttribution section={brandSection} />
      ) : null}
    </div>
  );
}

RenderProductPageUpsellSlot.propTypes = {
  popupData: PropTypes.object.isRequired,
  activeStep: PropTypes.number,
  isMobile: PropTypes.bool,
};
